module.exports = __webpack_public_path__ + "img/step23_a_printer_basic_remove_foam.5b1109d9.png";